import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

import { useState, useEffect, useRef } from 'preact/hooks'

import AuthForm from './components/AuthForm'
import Modal from './components/Modal'
import Recoveryform from './components/RecoveryForm'

import './style/index.css'
import { getAndSendImprintHash } from './helpers/imprint'

const App = () => {
  const [login, setLogin] = useState(null)
  const [openRecovery, setOpenRecovery] = useState(false)

  const loginInput = useRef(null)

  useEffect(() => {
    if (!openRecovery && login) {
      loginInput.current.value = login
    }
  }, [openRecovery, login, loginInput])

  useEffect(() => {
    getAndSendImprintHash()
  }, [])

  return (
    <GoogleReCaptchaProvider
      language="ru_RU"
      reCaptchaKey="6LcVxrYqAAAAAFC0UvfRWY1-pnHRcF72-JFWmm2l"
    >
      <AuthForm onClickForgot={setOpenRecovery} loginInputRef={loginInput} />
      {openRecovery && (
        <Modal
          name="Восстановление доступа к счету"
          onClickClose={setOpenRecovery}
        >
          <Recoveryform setLogin={setLogin} setOpenRecovery={setOpenRecovery} />
        </Modal>
      )}
    </GoogleReCaptchaProvider>
  )
}

export default App
